"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.get-prototype-of.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.set-prototype-of.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.reflect.to-string-tag.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.array.concat.js");
var _react = _interopRequireDefault(require("react"));
var _core = require("../../core");
var _Input = _interopRequireWildcard(require("../../core/Input"));
var _bricks = require("../../system/bricks.types");
var _hidden = require("../../system/hidden");
var _shared = require("./shared");
var _excluded = ["prefillBehavior"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function cov_12hwueqay6() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/CtaInput/CtaInput.tsx";
  var hash = "1860a5f6d48768bdd99cff7ccd36bb028ace23f6";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/CtaInput/CtaInput.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 28
        },
        end: {
          line: 11,
          column: 66
        }
      },
      "1": {
        start: {
          line: 12,
          column: 28
        },
        end: {
          line: 12,
          column: 73
        }
      },
      "2": {
        start: {
          line: 14,
          column: 50
        },
        end: {
          line: 103,
          column: 1
        }
      },
      "3": {
        start: {
          line: 32,
          column: 40
        },
        end: {
          line: 32,
          column: 89
        }
      },
      "4": {
        start: {
          line: 34,
          column: 2
        },
        end: {
          line: 57,
          column: 3
        }
      },
      "5": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 56,
          column: 6
        }
      },
      "6": {
        start: {
          line: 45,
          column: 12
        },
        end: {
          line: 45,
          column: 34
        }
      },
      "7": {
        start: {
          line: 59,
          column: 2
        },
        end: {
          line: 102,
          column: 3
        }
      },
      "8": {
        start: {
          line: 62,
          column: 6
        },
        end: {
          line: 77,
          column: 8
        }
      },
      "9": {
        start: {
          line: 71,
          column: 40
        },
        end: {
          line: 71,
          column: 64
        }
      },
      "10": {
        start: {
          line: 79,
          column: 6
        },
        end: {
          line: 101,
          column: 8
        }
      },
      "11": {
        start: {
          line: 106,
          column: 48
        },
        end: {
          line: 135,
          column: 3
        }
      },
      "12": {
        start: {
          line: 152,
          column: 8
        },
        end: {
          line: 152,
          column: 18
        }
      },
      "13": {
        start: {
          line: 154,
          column: 27
        },
        end: {
          line: 154,
          column: 77
        }
      },
      "14": {
        start: {
          line: 156,
          column: 4
        },
        end: {
          line: 196,
          column: 6
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 14,
            column: 50
          },
          end: {
            line: 14,
            column: 51
          }
        },
        loc: {
          start: {
            line: 31,
            column: 6
          },
          end: {
            line: 103,
            column: 1
          }
        },
        line: 31
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 44,
            column: 19
          },
          end: {
            line: 44,
            column: 20
          }
        },
        loc: {
          start: {
            line: 44,
            column: 25
          },
          end: {
            line: 46,
            column: 11
          }
        },
        line: 44
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 71,
            column: 20
          },
          end: {
            line: 71,
            column: 21
          }
        },
        loc: {
          start: {
            line: 71,
            column: 40
          },
          end: {
            line: 71,
            column: 64
          }
        },
        line: 71
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 111,
            column: 14
          },
          end: {
            line: 111,
            column: 15
          }
        },
        loc: {
          start: {
            line: 111,
            column: 20
          },
          end: {
            line: 111,
            column: 22
          }
        },
        line: 111
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 112,
            column: 15
          },
          end: {
            line: 112,
            column: 16
          }
        },
        loc: {
          start: {
            line: 112,
            column: 21
          },
          end: {
            line: 112,
            column: 23
          }
        },
        line: 112
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 113,
            column: 14
          },
          end: {
            line: 113,
            column: 15
          }
        },
        loc: {
          start: {
            line: 113,
            column: 20
          },
          end: {
            line: 113,
            column: 22
          }
        },
        line: 113
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 114,
            column: 13
          },
          end: {
            line: 114,
            column: 14
          }
        },
        loc: {
          start: {
            line: 114,
            column: 19
          },
          end: {
            line: 114,
            column: 21
          }
        },
        line: 114
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 115,
            column: 12
          },
          end: {
            line: 115,
            column: 13
          }
        },
        loc: {
          start: {
            line: 115,
            column: 18
          },
          end: {
            line: 115,
            column: 20
          }
        },
        line: 115
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 137,
            column: 2
          },
          end: {
            line: 137,
            column: 3
          }
        },
        loc: {
          start: {
            line: 137,
            column: 18
          },
          end: {
            line: 197,
            column: 3
          }
        },
        line: 137
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 34,
            column: 2
          },
          end: {
            line: 57,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 34,
            column: 2
          },
          end: {
            line: 57,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 34
      },
      "1": {
        loc: {
          start: {
            line: 52,
            column: 13
          },
          end: {
            line: 52,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 52,
            column: 13
          },
          end: {
            line: 52,
            column: 38
          }
        }, {
          start: {
            line: 52,
            column: 42
          },
          end: {
            line: 52,
            column: 81
          }
        }],
        line: 52
      },
      "2": {
        loc: {
          start: {
            line: 59,
            column: 2
          },
          end: {
            line: 102,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 60,
            column: 15
          }
        }, {
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 77,
            column: 8
          }
        }, {
          start: {
            line: 78,
            column: 4
          },
          end: {
            line: 101,
            column: 8
          }
        }],
        line: 59
      },
      "3": {
        loc: {
          start: {
            line: 68,
            column: 24
          },
          end: {
            line: 68,
            column: 87
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 68,
            column: 46
          },
          end: {
            line: 68,
            column: 65
          }
        }, {
          start: {
            line: 68,
            column: 68
          },
          end: {
            line: 68,
            column: 87
          }
        }],
        line: 68
      },
      "4": {
        loc: {
          start: {
            line: 69,
            column: 21
          },
          end: {
            line: 69,
            column: 58
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 69,
            column: 45
          },
          end: {
            line: 69,
            column: 46
          }
        }, {
          start: {
            line: 69,
            column: 49
          },
          end: {
            line: 69,
            column: 58
          }
        }],
        line: 69
      },
      "5": {
        loc: {
          start: {
            line: 80,
            column: 64
          },
          end: {
            line: 80,
            column: 97
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 80,
            column: 81
          },
          end: {
            line: 80,
            column: 87
          }
        }, {
          start: {
            line: 80,
            column: 90
          },
          end: {
            line: 80,
            column: 97
          }
        }],
        line: 80
      },
      "6": {
        loc: {
          start: {
            line: 181,
            column: 27
          },
          end: {
            line: 181,
            column: 78
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 181,
            column: 68
          },
          end: {
            line: 181,
            column: 74
          }
        }, {
          start: {
            line: 181,
            column: 77
          },
          end: {
            line: 181,
            column: 78
          }
        }],
        line: 181
      },
      "7": {
        loc: {
          start: {
            line: 188,
            column: 21
          },
          end: {
            line: 188,
            column: 80
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 188,
            column: 21
          },
          end: {
            line: 188,
            column: 51
          }
        }, {
          start: {
            line: 188,
            column: 55
          },
          end: {
            line: 188,
            column: 80
          }
        }],
        line: 188
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1860a5f6d48768bdd99cff7ccd36bb028ace23f6"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_12hwueqay6 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_12hwueqay6();
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; } // Similar to the CtaInputLite component, difference is that this component
// uses the <Input /> component, which is a very heavy dependency.
var INVALID_EMAIL_ERROR = (cov_12hwueqay6().s[0]++, "Looks like this isn't a valid email.");
var INVALID_PHONE_ERROR = (cov_12hwueqay6().s[1]++, "Looks like this isn't a valid phone number.");
cov_12hwueqay6().s[2]++;
var InputWrapperWithPrefill = function InputWrapperWithPrefill(_ref) {
  var ariaLabel = _ref.ariaLabel,
    ariaLabelledby = _ref.ariaLabelledby,
    inputType = _ref.inputType,
    placeholderText = _ref.placeholderText,
    value = _ref.value,
    autoComplete = _ref.autoComplete,
    autoFocus = _ref.autoFocus,
    _onChange = _ref.onChange,
    onKeyDown = _ref.onKeyDown,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    unboundedWidth = _ref.unboundedWidth,
    designStyle = _ref.designStyle,
    className = _ref.className,
    analyticsName = _ref.analyticsName,
    prefillBehavior = _ref.ctaProps.prefillBehavior;
  cov_12hwueqay6().f[0]++;
  var _ref2 = (cov_12hwueqay6().s[3]++, _react["default"].useState(Boolean(prefillBehavior))),
    _ref3 = _slicedToArray(_ref2, 2),
    showPrefill = _ref3[0],
    setShowPrefill = _ref3[1];
  cov_12hwueqay6().s[4]++;
  if (showPrefill) {
    cov_12hwueqay6().b[0][0]++;
    cov_12hwueqay6().s[5]++;
    return /*#__PURE__*/_react["default"].createElement(_core.Box, null, /*#__PURE__*/_react["default"].createElement(_core.Text, {
      fontWeight: 'semibold'
    }, value), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      "aria-label": "Edit input text",
      variant: "inline-link",
      textDecoration: "none",
      analyticsName: "prefill-edit-text",
      type: "button",
      onClick: function onClick() {
        cov_12hwueqay6().f[1]++;
        cov_12hwueqay6().s[6]++;
        setShowPrefill(false);
      }
    }, /*#__PURE__*/_react["default"].createElement(_core.Flex, {
      alignItems: 'center',
      gap: "2",
      justifyContent: "center"
    }, /*#__PURE__*/_react["default"].createElement(_core.Text, _extends({}, prefillBehavior.textProps, {
      textAlign: "center"
    }), prefillBehavior.editCtaText), (cov_12hwueqay6().b[1][0]++, prefillBehavior.iconProps) && (cov_12hwueqay6().b[1][1]++, /*#__PURE__*/_react["default"].createElement(_core.Icon, prefillBehavior.iconProps)))));
  } else {
    cov_12hwueqay6().b[0][1]++;
  }
  cov_12hwueqay6().s[7]++;
  switch (inputType) {
    case 'tel':
      cov_12hwueqay6().b[2][0]++;
    case 'email':
      cov_12hwueqay6().b[2][1]++;
      cov_12hwueqay6().s[8]++;
      return /*#__PURE__*/_react["default"].createElement(_Input["default"], {
        analyticsName: analyticsName,
        id: inputType,
        type: inputType,
        value: value,
        errorMessage: inputType === 'tel' ? (cov_12hwueqay6().b[3][0]++, INVALID_PHONE_ERROR) : (cov_12hwueqay6().b[3][1]++, INVALID_EMAIL_ERROR),
        minLength: inputType === 'email' ? (cov_12hwueqay6().b[4][0]++, 1) : (cov_12hwueqay6().b[4][1]++, undefined),
        name: inputType,
        onChange: function onChange(event) {
          cov_12hwueqay6().f[2]++;
          cov_12hwueqay6().s[9]++;
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }
          return _onChange.apply(void 0, [event].concat(args));
        },
        placeholder: placeholderText,
        unboundedWidth: unboundedWidth,
        borderRadius: designStyle,
        "aria-label": ariaLabel
      });
    default:
      cov_12hwueqay6().b[2][2]++;
      cov_12hwueqay6().s[10]++;
      return /*#__PURE__*/_react["default"].createElement(_core.Flex, {
        className: "input-container",
        width: ['100%', null, unboundedWidth ? (cov_12hwueqay6().b[5][0]++, '100%') : (cov_12hwueqay6().b[5][1]++, '350px')]
      }, /*#__PURE__*/_react["default"].createElement(_Input.InputBase, {
        name: "CtaInput",
        className: "cta-input-control cta-input-js ".concat(className),
        onFocus: onFocus,
        onBlur: onBlur,
        type: inputType,
        value: value,
        onChange: _onChange,
        onKeyDown: onKeyDown,
        placeholder: placeholderText,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        required: true,
        borderRadius: designStyle,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby,
        analyticsName: analyticsName,
        height: "56px"
      }));
  }
};
var CtaInput = exports["default"] = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(CtaInput, _React$PureComponent);
  function CtaInput() {
    _classCallCheck(this, CtaInput);
    return _callSuper(this, CtaInput, arguments);
  }
  _createClass(CtaInput, [{
    key: "render",
    value: function render() {
      var _ref5;
      cov_12hwueqay6().f[8]++;
      var _ref4 = (cov_12hwueqay6().s[12]++, this.props),
        onSubmit = _ref4.onSubmit,
        paddingLevel = _ref4.paddingLevel,
        showBorder = _ref4.showBorder,
        showShadow = _ref4.showShadow,
        unboundedWidth = _ref4.unboundedWidth,
        designStyle = _ref4.designStyle,
        failure = _ref4.failure,
        analyticsName = _ref4.analyticsName,
        _ref4$ctaProps = _ref4.ctaProps,
        _prefillBehavior = _ref4$ctaProps.prefillBehavior,
        ctaProps = _objectWithoutProperties(_ref4$ctaProps, _excluded);
      var mergedCtaProps = (cov_12hwueqay6().s[13]++, _objectSpread(_objectSpread({}, CtaInput.defaultProps.ctaProps), ctaProps));
      cov_12hwueqay6().s[14]++;
      return /*#__PURE__*/_react["default"].createElement(_shared.CtaInputWrapper, {
        className: "od-cta-input",
        unboundedWidth: unboundedWidth
      }, /*#__PURE__*/_react["default"].createElement(_shared.Wrapper, {
        className: "cta-input-wrapper",
        designStyle: designStyle,
        paddingLevel: paddingLevel,
        showBorder: showBorder,
        showShadow: showShadow,
        unboundedWidth: unboundedWidth,
        failure: failure
      }, /*#__PURE__*/_react["default"].createElement(_shared.FormWrapper, {
        shouldSubmitOnClick: mergedCtaProps.type === 'submit',
        onSubmit: onSubmit
      }, /*#__PURE__*/_react["default"].createElement(_shared.InputWrapper, {
        unboundedWidth: unboundedWidth,
        designStyle: designStyle
      }, /*#__PURE__*/_react["default"].createElement(InputWrapperWithPrefill, this.props)), /*#__PURE__*/_react["default"].createElement(_shared.InputButton, {
        className: "cta-input-button"
      }, /*#__PURE__*/_react["default"].createElement(_core.Button, _extends({
        className: "cta-button",
        analyticsName: "".concat(analyticsName, "-cta-button"),
        onClick: mergedCtaProps.onClick,
        size: mergedCtaProps.size,
        variant: mergedCtaProps.variant,
        type: mergedCtaProps.type,
        loadingText: mergedCtaProps.loadingText,
        loading: mergedCtaProps.loading,
        marginTop: mergedCtaProps.marginType === 'medium' ? (cov_12hwueqay6().b[6][0]++, '10px') : (cov_12hwueqay6().b[6][1]++, 0),
        borderRadius: designStyle
      }, mergedCtaProps), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_bricks.bricks.span, {
        css: _hidden.hiddenXsDown
      }, mergedCtaProps.actionText), /*#__PURE__*/_react["default"].createElement(_bricks.bricks.span, {
        css: _hidden.hiddenXsUp
      }, (_ref5 = (cov_12hwueqay6().b[7][0]++, mergedCtaProps.actionTextSmall)) !== null && _ref5 !== void 0 ? _ref5 : (cov_12hwueqay6().b[7][1]++, mergedCtaProps.actionText))))))));
    }
  }]);
  return CtaInput;
}((_react["default"].PureComponent));
_defineProperty(CtaInput, "defaultProps", (cov_12hwueqay6().s[11]++, {
  autoComplete: 'on',
  autoFocus: true,
  className: '',
  designStyle: 'roundedSquare',
  onChange: function onChange() {
    cov_12hwueqay6().f[3]++;
  },
  onKeyDown: function onKeyDown() {
    cov_12hwueqay6().f[4]++;
  },
  onSubmit: function onSubmit() {
    cov_12hwueqay6().f[5]++;
  },
  onFocus: function onFocus() {
    cov_12hwueqay6().f[6]++;
  },
  onBlur: function onBlur() {
    cov_12hwueqay6().f[7]++;
  },
  paddingLevel: 'medium',
  showBorder: true,
  showShadow: false,
  value: '',
  inputType: 'text',
  unboundedWidth: false,
  ctaProps: {
    actionText: 'Go',
    actionTextSmall: 'Go',
    size: 'md',
    'aria-label': 'Input text',
    variant: 'primary',
    type: 'submit',
    disabled: false,
    prefillBehavior: undefined,
    loadingText: 'Loading ...',
    loading: false,
    marginType: 'none'
  }
}));